var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { EHRErrorCode } from 'constants/ehrErrorData';
import { adminMfa, adminSignIn, compassForbidden } from 'constants/externalRoutes';
import { useEffect } from 'react';
import { EHR_URL } from '../../config';
import { useLocalStorage } from './useLocalStorage';
// first API call can 401 if initial token not set on axios init
var initialToken = window.localStorage.getItem('access_token');
var axiosInstance = axios.create({
    baseURL: EHR_URL,
    headers: {
        Authorization: "Bearer ".concat(initialToken),
    },
});
export var useAxiosInterceptors = function () {
    var token = useLocalStorage('access_token', '', false)[0];
    useEffect(function () {
        var authInterceptor = axiosInstance.interceptors.request.use(function (config) {
            config.headers = __assign(__assign({}, config.headers), { Authorization: "Bearer ".concat(token) });
            return config;
        });
        return function () { return axiosInstance.interceptors.request.eject(authInterceptor); };
    }, [token]);
    useEffect(function () {
        var authInterceptor = axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) {
            var _a;
            var _b = (_a = error.response) !== null && _a !== void 0 ? _a : {}, status = _b.status, data = _b.data;
            if (status === 403) {
                window.location.href = process.env.REACT_APP_LOCAL_CG_ENV ? '/403' : compassForbidden;
            }
            if (status === 401) {
                if ((data === null || data === void 0 ? void 0 : data.code) === EHRErrorCode.mfaDisabled) {
                    window.location.href = adminMfa;
                }
                else {
                    // let people sign in on local dev
                    if (!process.env.REACT_APP_LOCAL_CG_ENV ||
                        !window.location.pathname.includes('sign_in')) {
                        window.location.href = adminSignIn;
                    }
                }
            }
            return Promise.reject(error);
        });
        return function () { return axiosInstance.interceptors.request.eject(authInterceptor); };
    }, []);
    return axiosInstance;
};
export var useAxios = function () {
    return axiosInstance;
};
